var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreCost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.353 100.352",
    style: {
      enableBackground: "new 0 0 100.353 100.352"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.779,73.231c7.675,0,13.92-6.245,13.92-13.92s-6.245-13.92-13.92-13.92s-13.92,6.245-13.92,13.92 S34.104,73.231,41.779,73.231z M41.779,48.391c6.021,0,10.92,4.898,10.92,10.92s-4.898,10.92-10.92,10.92s-10.92-4.898-10.92-10.92 S35.757,48.391,41.779,48.391z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.985,
    y: 46.891,
    width: 3,
    height: 24.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.102,
    y: 46.891,
    width: 3,
    height: 24.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.683,19.21H20.434v8.898h-8.201v9.726H3.318v42.954h76.249v-9.726h8.915v-8.898h8.2V19.21H96.683z M76.567,77.788H6.318 V40.834h70.249V77.788z M85.482,68.063h-5.915V37.834H15.233v-6.726h70.25L85.482,68.063L85.482,68.063z M93.683,59.164h-5.2 V28.108H23.434V22.21h70.249L93.683,59.164L93.683,59.164z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreCost);
export default __webpack_public_path__ + "static/media/store_cost.f3c56d47402035b7d9d953dfa5572434.svg";
export { ForwardRef as ReactComponent };